import { cn } from "../lib/cn.js";
import {
  ENTITLEMENT_OPTIONS,
  formatEntitlementLabel
} from "../lib/entitlements.js";

interface EntitlementChecklistProps {
  value: string[];
  onChange: (value: string[]) => void;
  columns?: 2 | 3;
}

export function EntitlementChecklist({
  value,
  onChange,
  columns = 2
}: EntitlementChecklistProps) {
  const selected = new Set(value);
  const knownValues = new Set(ENTITLEMENT_OPTIONS.map((option) => option.value));
  const unknownEntitlements = value.filter((item) => !knownValues.has(item));
  const update = (entitlement: string, checked: boolean) => {
    if (checked) {
      onChange([...value, entitlement].filter((item, index, items) => items.indexOf(item) === index));
      return;
    }
    onChange(value.filter((item) => item !== entitlement));
  };

  return (
    <div className="rounded border border-surface-border bg-surface-panel p-2">
      <div
        className={cn(
          "grid grid-cols-1 gap-2",
          columns === 3 ? "md:grid-cols-3" : "md:grid-cols-2"
        )}
      >
        {ENTITLEMENT_OPTIONS.map((option) => (
          <label
            key={option.value}
            className="flex min-h-[52px] gap-2 rounded border border-surface-border bg-surface-raised px-2.5 py-2 text-sm"
          >
            <input
              type="checkbox"
              className="mt-0.5 h-4 w-4"
              checked={selected.has(option.value)}
              onChange={(event) => update(option.value, event.target.checked)}
            />
            <span>
              <span className="block text-text-primary">{option.label}</span>
              <span className="block text-xs text-text-muted">{option.description}</span>
            </span>
          </label>
        ))}
      </div>
      {unknownEntitlements.length > 0 && (
        <div className="mt-2 rounded border border-status-warning/30 bg-status-warning/10 px-2.5 py-2 text-xs text-text-secondary">
          保留历史能力：{unknownEntitlements.map(formatEntitlementLabel).join("、")}
        </div>
      )}
    </div>
  );
}
